import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingSpinnerFuseComponent } from '../../loading-spinner-fuse/loading-spinner-fuse.component';

@Component({
  selector: 'app-ponctual-confirm-button-fuse',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslateModule,
    LoadingSpinnerFuseComponent,
  ],
  templateUrl: './ponctual-confirm-button-fuse.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PonctualConfirmButtonFuseComponent {
  @Input() selectionsCount: number = 0;
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() mode: 'standard' | 'lilate' = 'standard';

  @Output() confirm = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled && !this.loading) {
      this.confirm.emit();
    }
  }

  get buttonText(): string {
    if (this.loading) {
      return 'feature.ponctual-schedule.Réservation en cours...';
    }

    if (this.mode === 'lilate') {
      return 'feature.ponctual-schedule.Réserver votre LILATE';
    }

    if (this.selectionsCount === 0) {
      return 'feature.ponctual-schedule.un cours';
    } else if (this.selectionsCount === 1) {
      return 'feature.ponctual-schedule.ce cours';
    } else {
      return 'feature.ponctual-schedule.ces cours';
    }
  }
}
